module.exports = __webpack_public_path__ + "static/village_card_img2@2x-5fc7b56ab41cd6d8b1269791341a4a87.png";